<template>
    <section>
     <Header 
        :header_page_data="headerPageData"
     ></Header>
     <DeleteAccountModal></DeleteAccountModal>
      <section>
        <div class="container container-app">
            <section class="position-relative profile-container mt-3">
                <h3 class="notifications-title">{{ $t('profile.notifications') }}</h3>
                <div class="profile-notifications-scroll-container">
                    <span class="no-results-found-label" v-if="notifications.length == 0">{{ $t('profile.no_results_found') }}</span>
                    <div v-for="(notification, index) in notifications" class="row mb-2" :key="index">
                        <div v-if="notification.type == 'volunteer_wants_to_join_campaign'" @click.prevent="flagSeenNotification(notification); gotoCampaignNotification(notification, 'volunteer_wants_to_join_campaign')" class="col-12 notification">
                            <span :class="{'grey-notification': notificationsSeenArray.includes(notification._id)}" class="mr-2 font-weight-bold">{{ notificationsSeenArray.includes(notification._id) ? '&#10003;' : '#' }}&nbsp;{{notification.data.name}}</span><span :class="{'grey-notification': notificationsSeenArray.includes(notification._id)}">{{$t('profile.volunteer_wants_to_join_campaign')}}</span><span :class="{'grey-notification': notificationsSeenArray.includes(notification._id)}">&nbsp;{{typeof notification.data.campaign_name != 'undefined' ? notification.data.campaign_name + ' ' + $t('profile.campaign') : $t('profile.your_campaign')}}.</span>
                       </div>
                       <div v-else-if="notification.type == 'volunteer_accepted_in_campaign'" @click.prevent="flagSeenNotification(notification); gotoCampaignNotification(notification, 'volunteer_accepted_in_campaign')" class="col-12 notification">
                            <span :class="{'grey-notification': notificationsSeenArray.includes(notification._id)}" class="mr-2 font-weight-bold">{{ notificationsSeenArray.includes(notification._id) ? '&#10003;' : '#' }}&nbsp;{{notification.data.name}}</span><span :class="{'grey-notification': notificationsSeenArray.includes(notification._id)}">{{$t('profile.accepted_request_to_join')}}</span><span :class="{'grey-notification': notificationsSeenArray.includes(notification._id)}">&nbsp;{{typeof notification.data.campaign_name != 'undefined' ? notification.data.campaign_name + ' ' + $t('profile.campaign') : $t('profile.your_campaign')}}.</span>
                       </div>
                       <div v-else-if="notification.type == 'volunteer_reactivated_in_campaign'" @click.prevent="flagSeenNotification(notification); gotoCampaignNotification(notification, 'volunteer_reactivated_in_campaign')" class="col-12 notification">
                            <span :class="{'grey-notification': notificationsSeenArray.includes(notification._id)}" class="mr-2 font-weight-bold">{{ notificationsSeenArray.includes(notification._id) ? '&#10003;' : '#' }}&nbsp;{{notification.data.name}}</span><span :class="{'grey-notification': notificationsSeenArray.includes(notification._id)}">{{$t('profile.reactivated_user')}}</span><span :class="{'grey-notification': notificationsSeenArray.includes(notification._id)}">&nbsp;{{typeof notification.data.campaign_name != 'undefined' ? notification.data.campaign_name + ' ' + $t('profile.campaign') : $t('profile.your_campaign')}}.</span>
                       </div>
                       <div v-else-if="notification.type == 'volunteer_rejected_in_campaign'" @click.prevent="flagSeenNotification(notification); gotoCampaignNotification(notification, 'volunteer_rejected_in_campaign')" class="col-12 notification">
                            <span :class="{'grey-notification': notificationsSeenArray.includes(notification._id)}" class="mr-2 font-weight-bold">{{ notificationsSeenArray.includes(notification._id) ? '&#10003;' : '#' }}&nbsp;{{notification.data.name}}</span><span :class="{'grey-notification': notificationsSeenArray.includes(notification._id)}">{{$t('profile.denied_your_request_to_join')}}</span><span :class="{'grey-notification': notificationsSeenArray.includes(notification._id)}">&nbsp;{{typeof notification.data.campaign_name != 'undefined' ? notification.data.campaign_name + ' ' + $t('profile.campaign') : $t('profile.your_campaign')}}.</span>
                       </div>
                       <div v-else-if="notification.type == 'volunteer_removed_from_campaign'" @click.prevent="flagSeenNotification(notification); gotoCampaignNotification(notification, 'volunteer_removed_from_campaign')" class="col-12 notification">
                            <span :class="{'grey-notification': notificationsSeenArray.includes(notification._id)}" class="mr-2 font-weight-bold">{{ notificationsSeenArray.includes(notification._id) ? '&#10003;' : '#' }}&nbsp;{{notification.data.name}}</span><span :class="{'grey-notification': notificationsSeenArray.includes(notification._id)}">{{$t('profile.volunteer_removed_from_campaign')}}</span><span :class="{'grey-notification': notificationsSeenArray.includes(notification._id)}">&nbsp;{{typeof notification.data.campaign_name != 'undefined' ? notification.data.campaign_name + ' ' + $t('profile.campaign') : $t('profile.your_campaign')}}.</span>
                       </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="hr"></div>
                    </div>
                </div>
                <h3 class="notifications-title mt-3">{{ $t('profile.profile_details') }}</h3>
                <div v-if="editName == false" class="row">
                    <div class="col-12">
                        {{ name }}
                    </div>
                    <div class="col-12">
                        <span class="edit-save-name cursor-pointer" @click.prevent="editNameFct()">{{$t('profile.edit_name')}}</span>
                    </div>
                </div>
                <div v-else class="row">
                    <div class="col-12">
                        <input type="text" class="form-control form-control--canvassing border-bottom" :placeholder="$t('profile.name')" v-model="name" id="name">
                        <div v-if="hasError(nameError, 'name')">
                            <span class="text-danger">{{nameError.name[0]}}</span>
                        </div>
                    </div>
                    <div class="col-12">
                        <span class="edit-save-name cursor-pointer" @click.prevent="saveNameFct()">{{$t('profile.save_name')}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        {{this.$store.getters["user"] ? this.$store.getters["user"].email : ''}}
                    </div>
                </div>
                <form class="mt-5">
                    <div class="form-group position-relative">
                        <div class="mt-3 mb-3 text-center" v-if="showResetPasswordMessage">
                            <span class="confirm-register-message text-center">{{ $t('profile.reset_message') }}</span>
                        </div>
                        <span class="login-input-title float-left">{{ $t('profile.reset_password') }}</span>
                        <input type="password" class="form-control form-control--canvassing border-bottom" :placeholder="$t('profile.old_password')" v-model="formReset.old_password" id="old_password">
                        <div v-if="hasError(formResetErrors, 'old_password')">
                            <span class="text-danger">{{formResetErrors.old_password[0]}}</span>
                        </div>
                    </div>
                    <div class="form-group position-relative">
                        <input type="password" class="form-control form-control--canvassing border-bottom" :placeholder="$t('profile.password')" v-model="formReset.password" id="password">
                        <div v-if="hasError(formResetErrors, 'password')">
                            <span class="text-danger">{{formResetErrors.password[0]}}</span>
                        </div>
                    </div>
                     <div class="form-group position-relative">
                        <input type="password" class="form-control form-control--canvassing border-bottom" :placeholder="$t('profile.confirm_password')" v-model="formReset.confirm_password" id="confirm_password">
                        <div v-if="hasError(formResetErrors, 'confirm_password')">
                            <span class="text-danger">{{formResetErrors.confirm_password[0]}}</span>
                        </div>
                    </div>

                    <div class="row mb-5">
                        <div class="col-12">
                            <span class="edit-save-name cursor-pointer" @click.prevent="doSavePassword()">{{$t('profile.save_password')}}</span>
                        </div>
                    </div>

                    <h3 class="notifications-title mt-3">{{ $t('profile.notifications_settings') }}</h3>

                    <div class="row mb-5">
                        <div v-if="!pushNotifications" class="col-8">
                            {{ $t('profile.active') }}
                        </div>
                        <div v-else class="col-8">
                            {{ $t('profile.deactivate') }}
                        </div>
                        <div class="col-4">
                            <label class="switch">
                                <input v-model="pushNotifications" @change="registerPushNotifications" type="checkbox" :checked="pushNotifications">
                                <span class="slider round"></span>
                            </label>
                        </div>
                    </div>

                    <div class="row mb-5">
                        <div class="col-12">
                            {{$t('profile.push_notifications_note')}}
                        </div>
                    </div>

                    <h3 class="notifications-title mt-3">{{ $t('profile.app_to_homescreen') }}</h3>

                    <div v-if="canShowInstallAppProfile" class="row mb-5">
                        <div class="col-12">
                            <span class="edit-save-name cursor-pointer" @click="installProfile">{{$t('profile.add_app_to_homescreen')}}</span>
                        </div>
                    </div>

                    <div class="row mb-5">
                        <div class="col-12">
                            {{$t('profile.ios_note')}}
                        </div>
                    </div>

                     <div class="row modal-footer-canvassing-redish">
                        <div class="col-12 mt-4 mb-4 d-flex">
                            <span data-toggle="modal" data-target="#deleteAccountModal" class="modal-footer-canvassing-red-button mx-auto cursor-pointer">{{ $t('profile.delete_account') }}</span>
                        </div>
                        <div class="col-12 text-center mb-2">
                            <p class="note-text">{{ $t('profile.note_delete') }}</p>
                        </div>
                    </div>
                </form>
            </section>
        </div>
      </section>
    </section>
</template>

<script>
    import Cookies from "js-cookie";
    import Header from "../layouts/Header";
    import DeleteAccountModal from "../modals/DeleteAccountModal";
    import HelperMixin from "../../mixins/HelperMixin";

    function urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }

    export default {
        name: "Profile",
        components: {Header, DeleteAccountModal},
        mixins: [HelperMixin],
        data() {
            return {
                pushNotifications: false,
                isMobileProfile: false,
                isIosVarProfile: false,
                deferredPromptProfile: window.deferred,
                canShowInstallAppProfile: false,
                notificationsSeenArray: [],
                stopLoad: false,
                page: 2,
                showResetPasswordMessage: false,
                nameError: {
                    name: []
                },
                formReset: {
                    old_password: '',
                    password: '',
                    confirm_password: '',
                },
                formResetErrors: {
                    old_password: [],
                    password: [],
                    confirm_password: [],
                },
                name: '',
                editName: false,
                notifications: [],
                headerPageData: {
                    title: this.$t('profile.title'),
                    search: {
                        show: false,
                        type_search: ''
                    },
                    settings: {
                        show: false,
                    },
                    home: {
                        show: true,
                    },
                    profile: {
                        show: false
                    }
                }
            }
        },
        mounted() {
            let _this = this;
            $('.profile-notifications-scroll-container').scroll(function() {
                if (_this.stopLoad != true) {
                    let div = $(this).get(0);
                    if(div.scrollTop + div.clientHeight >= div.scrollHeight) {
                        _this.getMoreAlerts(_this.page);
                    }
                }
                
            });
        },

        created() {
            this.isIosProfile();
            this.isMobileFctProfile();
            this.canShowInstallAppFctProfile();
            let _this = this;
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.ready.then(function(reg) {
                    reg.pushManager.getSubscription().then(function(subscription) {
                        if (subscription) {
                            _this.pushNotifications = true;
                        } else {
                            _this.pushNotifications = false;
                        }
                    })        
                });
            }

            if (localStorage.seenNotifications) {
                    this.notificationsSeenArray = JSON.parse(localStorage.seenNotifications);
                } else {
                    this.notificationsSeenArray = [];
                }
            this.page = 2;
            if (this.$store.getters["user"]) {
                this.name = this.$store.getters["user"] ? this.$store.getters["user"].name : '';
            }
            this.refreshProfileData();
            if (this.$store.getters["alerts"].length > 0) {
                this.getNotifications();
            }
            this.showResetPasswordMessage = false;
        },
        methods: {
            registerPushNotifications() {
                if (this.pushNotifications) {
                    if ('serviceWorker' in navigator) {
                        navigator.serviceWorker.register('serviceWorker.js');
                        navigator.serviceWorker.ready.then(registration => {
                            if ('PushManager' in window) {
                                this.registerForPush(registration.pushManager)
                            }
                        });
                    } else {
                        //alert not available
                    } 
                } else {
                    this.removeFromPush();
                }
            },

            removeFromPush() {
                let _this = this;
                if ('serviceWorker' in navigator) {
                    navigator.serviceWorker.ready.then(function(reg) {
                        reg.pushManager.getSubscription().then(function(subscription) {
                            subscription.unsubscribe().then(function(successful) {
                                console.log('unregistered push notifications');
                                _this.unregisterPushToServer();
                            }).catch(function(e) {
                            // Unsubscription failed
                            })
                        })        
                    });
                }
            },

            async registerForPush(pushManager) {
                let _this = this;
                try {
                    const applicationServerKey = 'BEzaQYc41E71VcL7H_gMpsPqX5825Ox--VcIZXwZgK4J_lUKfqIpCTzDpv0gjhqvZumSongvsJba_HD1vitswYk';
                    const subscription = await pushManager.subscribe({
                        userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(applicationServerKey) 
                    }).then(function(subscription) {
                        console.log('registered push notifications');
                        _this.registerPushToServer(JSON.stringify(subscription.toJSON()));
                    }).catch(function(e) {
                        if (Notification.permission === 'denied') {
                            console.warn('Permission for notifications was denied');
                        } else {
                            console.error('Unable to subscribe to push', e);
                        }
                    });

                } catch (error) {
                    console.error(error);
                }
            },

            unregisterPushToServer() {
                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };
                
                axios.post(
                        '/api/v1/user/delete-push',
                        {},
                        config
                ).then(this.consumeunregisterPushToServer, this.errorunregisterPushToServer);
            },

            consumeunregisterPushToServer: function (response) {
                
            },

            errorunregisterPushToServer: function (error) {
                console.log(error.response)
            },

            registerPushToServer(subscription) {
                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };
                
                axios.post(
                        '/api/v1/user/create-push',
                        {
                            user_push: subscription
                        },
                        config
                ).then(this.consumeregisterPushToServer, this.errorregisterPushToServer);
            },

            consumeregisterPushToServer: function (response) {
                
            },

            errorregisterPushToServer: function (error) {
                console.log(error.response)
            },

            isMobileFctProfile() {
                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
                // true for mobile device
                this.isMobileProfile = true;
                }else{
                // false for not mobile device
                this.isMobileProfile = false;
                }
            },

            canShowInstallAppFctProfile() {
                if ((this.isMobileProfile && this.$store.getters["isInstalledPWA"] == false)) {
                    this.canShowInstallAppProfile = true;
                } else {
                    this.canShowInstallAppProfile = false;
                }
                this.$forceUpdate();
            },

            isIosProfile() {
                // Detects if device is on iOS 
                const isIosProfile = () => {
                const userAgent = window.navigator.userAgent.toLowerCase();
                    return /iphone|ipad|ipod/.test( userAgent );
                }
                // Detects if device is in standalone mode
                const isInStandaloneModeProfile = () => ('standalone' in window.navigator) && (window.navigator.standalone);
                // Checks if should display install popup notification:
                if (isIosProfile() && !isInStandaloneModeProfile()) {
                    this.isIosVarProfile = true;
                } else {
                    this.isIosVarProfile = false;
                }
            },

            async installProfile() {
                this.$store.getters["deferredPWA"].prompt();
            },

            getMoreAlerts(page = 2) {
                 this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };
                let sendData = {
                    page: page
                }
                axios.post(
                        '/api/v1/user/alerts',
                        sendData,
                        config
                ).then(this.consumegetMoreAlerts, this.errorgetMoreAlerts);
                
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
            },

            consumegetMoreAlerts: function (response) {
                if (response.data.data.last_page >= this.page) {                
                    for (var i = 0; i < response.data.data.data.length; i++) {
                        this.notifications.push(response.data.data.data[i]);
                    }
                }
                this.page = this.page + 1;
                if (this.page > response.data.data.last_page) {
                    this.stopLoad = true;
                }
                
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
            },

            errorgetMoreAlerts: function (error) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                console.log(error);
            },

            flagSeenNotification(notification) {
                if (!this.notificationsSeenArray.includes(notification._id)) {
                    if (localStorage.seenNotifications) {
                        var seenNotifications = JSON.parse(localStorage.seenNotifications);
                    } else {
                        var seenNotifications = [];
                    }
                    seenNotifications.push(notification._id);
                    var encodedNotifications = JSON.stringify(seenNotifications);
                    localStorage.seenNotifications = encodedNotifications;   
                }
            },

            gotoCampaignNotification(notification, type) {
                if (!this.notificationsSeenArray.includes(notification._id)) {
                    if (type == 'volunteer_wants_to_join_campaign') {
                        this.goto('campaign-teams', {campaign_id: notification.data.campaign_id});
                    } else if (type == 'volunteer_accepted_in_campaign') {
                         this.goto('campaign-map', {campaign_id: notification.data.campaign_id});
                    } else if (type == 'volunteer_reactivated_in_campaign') {
                         this.goto('campaign-map', {campaign_id: notification.data.campaign_id});
                    } else if (type == 'volunteer_rejected_in_campaign') {
                         this.goto('campaign_list', {});
                    } else if (type == 'volunteer_removed_from_campaign') {
                         this.goto('campaign_list', {});
                    }
                }
            },

            resetNameErrors() {
                this.nameError = {
                    name: []
                };
            },

            resetPasswordErrors() {
                this.formResetErrors = {
                    old_password: [],
                    password: [],
                    confirm_password: [],
                };
            },

            resetPasswordForm() {
                this.formReset = {
                    old_password: '',
                    password: '',
                    confirm_password: '',
                };
            },

            doSavePassword() {
                 this.resetPasswordErrors();
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };
                axios.post(
                        '/api/v1/user/update',
                        this.formReset,
                        config
                ).then(this.consumedoSavePassword, this.errordoSavePassword);
            },

            consumedoSavePassword: function (response) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                this.resetPasswordForm();
                this.showResetPasswordMessage = true;
            },

            errordoSavePassword: function (error) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                if (
                    error.response !== undefined &&
                    error.response.data !== undefined &&
                    error.response.data.responseType === 'Error' &&
                    error.response.data.errorMessage !== undefined 
                ) {
                    if (typeof error.response.data.errorMessage.validation_fail != 'undefined') {
                        if (typeof error.response.data.errorMessage.validation_fail.password != 'undefined') {
                            if (error.response.data.errorMessage.validation_fail.password.includes("required_with")) {
                                this.formResetErrors.password = [this.$t('profile.errors.pasword_required_with')];
                            }
                            if (error.response.data.errorMessage.validation_fail.password.includes("required_without")) {
                                this.formResetErrors.password = [this.$t('profile.errors.pasword_required_with')];
                            }
                        }
                        if (typeof error.response.data.errorMessage.validation_fail.old_password != 'undefined') {
                            if (error.response.data.errorMessage.validation_fail.old_password.includes("required_with")) {
                                this.formResetErrors.old_password = [this.$t('profile.errors.old_pasword_required_with')];
                            }
                            if (error.response.data.errorMessage.validation_fail.old_password.includes("required_without")) {
                                this.formResetErrors.old_password = [this.$t('profile.errors.old_pasword_required_with')];
                            }
                            if (error.response.data.errorMessage.validation_fail.old_password.includes("incorrect")) {
                                this.formResetErrors.old_password = [this.$t('profile.errors.old_pasword_incorrect')];
                            }
                        }
                        if (typeof error.response.data.errorMessage.validation_fail.confirm_password != 'undefined') {
                            if (error.response.data.errorMessage.validation_fail.confirm_password.includes("required_with")) {
                                this.formResetErrors.confirm_password = [this.$t('profile.errors.confirm_password_required_with')];
                            }
                            if (error.response.data.errorMessage.validation_fail.confirm_password.includes("required_without")) {
                                this.formResetErrors.confirm_password = [this.$t('profile.errors.confirm_password_required_with')];
                            }
                            if (error.response.data.errorMessage.validation_fail.confirm_password.includes("same")) {
                                this.formResetErrors.confirm_password = [this.$t('profile.errors.confirm_password_same')];
                            }
                        }
                    }
                }
               console.log(error);
            },

            saveNameFct() {
                this.resetNameErrors();
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };
                axios.post(
                        '/api/v1/user/update',
                        {
                            name: this.name
                        },
                        config
                ).then(this.consumesaveNameFct, this.errorsaveNameFct);
            },

            consumesaveNameFct: function (response) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                let user =  this.$store.getters["user"];
                user.name = this.name;
                this.$store.dispatch('saveUser', {
                    user: user
                });
                this.editName = false;
            },

            errorsaveNameFct: function (error) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                if (
                    error.response !== undefined &&
                    error.response.data !== undefined &&
                    error.response.data.responseType === 'Error' &&
                    error.response.data.errorMessage !== undefined 
                ) {
                    if (typeof error.response.data.errorMessage.validation_fail != 'undefined') {
                        if (typeof error.response.data.errorMessage.validation_fail.name != 'undefined') {
                            if (error.response.data.errorMessage.validation_fail.name.includes("required_without_all")) {
                                this.nameError.name = [this.$t('profile.errors.name_required_without_all')];
                            }
                        }
                    }
                }
               console.log(error);
            },

            editNameFct() {
                this.editName = true;
            },

            getNotifications() {
                if (this.$store.getters["alerts"].length > 0) {
                    this.$store.dispatch('saveAlertLastDate', {
                        alertLastDate: this.$store.getters["alerts"][0].created_at
                    });
                }
                this.notifications = this.$store.getters["alerts"];
            },

            refreshProfileData() {
                if (this.$store.getters["user"] === null) {
                    if (typeof this.$store.getters["token"] == 'undefined') {
                         this.$router.replace({ name: "login"});
                    }
                    this.refreshData();
                }
            }
        },
    };
</script>
